import { FaTag } from "react-icons/fa6";
import { LuCodeXml, LuPalette, LuTelescope, LuBox, LuScale, LuBadgeDollarSign } from "react-icons/lu";

// Updated color palette with new hex values (for user avatars)
export const pastelColors = [
  { bg: 'bg-[#F5C8BD]', hex: '#F5C8BD' },
  { bg: 'bg-[#E9BACC]', hex: '#E9BACC' },
  { bg: 'bg-[#D0AAB0]', hex: '#D0AAB0' },
  { bg: 'bg-[#B599C1]', hex: '#B599C1' },
  { bg: 'bg-[#ABACCB]', hex: '#ABACCB' },
  { bg: 'bg-[#9FBFDD]', hex: '#9FBFDD' },
  { bg: 'bg-[#97CCDC]', hex: '#97CCDC' },
  { bg: 'bg-[#83C4B4]', hex: '#83C4B4' },
  { bg: 'bg-[#A9D194]', hex: '#A9D194' },
  { bg: 'bg-[#D5E4AD]', hex: '#D5E4AD' },
  { bg: 'bg-[#FAEEAE]', hex: '#FAEEAE' },
  { bg: 'bg-[#F5BE6B]', hex: '#F5BE6B' }
];

// Preset tag colors
export const tagColors = [
  '#3B82F6', // Blue
  '#10B981', // Green
  '#F59E0B', // Yellow
  '#EF4444', // Red
  '#8B5CF6', // Purple
  '#F97316', // Orange
  '#06B6D4', // Cyan
  '#84CC16', // Lime
  '#EC4899', // Pink
  '#6B7280', // Gray
];

// Tag icon options
export const tagIcons = [
  { id: 'tag', name: 'Default', icon: FaTag },
  { id: 'code', name: 'Code', icon: LuCodeXml },
  { id: 'design', name: 'Design', icon: LuPalette },
  { id: 'research', name: 'Research', icon: LuTelescope },
  { id: 'product', name: 'Product', icon: LuBox },
  { id: 'legal', name: 'Legal', icon: LuScale },
  { id: 'finance', name: 'Finance', icon: LuBadgeDollarSign },
]; 